<template>
  <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%">
    <el-table-column
            fixed
            type="index"
            label="序号"
            :index="indexMethod"
            width="100">
    </el-table-column>
    <el-table-column
            fixed
            prop="skuNo"
            label="商品编号"
            width="180">
    </el-table-column>
    <el-table-column
            prop="merchantsName"
            label="所属农基商"
            width="180">
    </el-table-column>
    <el-table-column
            prop="activityClassify"
            label="商品类型"
            width="180">
    </el-table-column>
    <el-table-column
            prop="specialClassify"
            label="商品特殊分类"
            width="180">
    </el-table-column>
    <el-table-column
            prop="pmsSkuClassify.classifyName"
            label="类别"
            width="180">
    </el-table-column>
    <el-table-column
            prop="skuName"
            label="商品名称"
            width="180">
    </el-table-column>
    <el-table-column
            prop="createTime"
            label="创建日期"
            width="180">
    </el-table-column>
    <el-table-column
            prop="isShelves"
            label="状态（0上架，1下架，2封仓）"
            width="180">
    </el-table-column>
    <el-table-column
            prop="skuInventory"
            label="拥有库存"
            width="180">
    </el-table-column>
    <el-table-column
            fixed="right"
            label="操作"
            width="150">
      <template slot-scope="scope">
        <el-button type="text" size="small" @click="view(scope.row.id)">查看</el-button>
        <el-button type="text" size="small" @click="update(scope.row.id)">修改</el-button>
        <el-button type="text" size="small" @click="del(scope.row.id)">
          <p class="red">删除</p>
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
  import {delSkuInfoBySkuId} from "../../network/skuInfo";

  export default {
    name: "skuInfoTable",
    props: {
      tableData: Array
    },
    data() {
      return {
      }
    },
    methods: {
      indexMethod(index) {
        return index+1;
      },
      view(id){
        this.$router.push("/pmsSkuInfo/data/"+id)
      },
      update(id){
        this.$router.push("/pmsSkuInfo/insert/"+id)
      },
      del(id){
        this.$confirm('此操作将永久删除该商品, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$emit("del",id)

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

      }
    },
  }
</script>

<style scoped>
  .red{
    color: red;
  }
</style>
